export const ADD_PRODUCTS = "ADD_PRODUCTS";
export const ADD_TO_BASKET = "ADD_TO_BASKET";
export const REMOVE_BASKET = "REMOVE";
export const INCREASE_PRODUCT = "INCREASE";
export const DICREASE_PRODUCT = "DICREASE";
export const EMPTY_BASKET = "EMPTY_BASKET";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const SET_CATEGORIES = "ADD_CATEGORY";
export const SET_CATEGORY = "SET_CATEGORY";
